import html2pdf from "html2pdf.js";
import React from "react";
import ReactDOM from "react-dom";

// Componente Modal para exibir o progresso
const ProgressModal = ({ status, message, visible }) => {
  if (!visible) return null;

  return (
    <div className="pdf-progress-modal-overlay">
      <div className="pdf-progress-modal">
        <div className={`pdf-progress-status ${status}`}>
          {status === "loading" && <div className="pdf-progress-spinner"></div>}
          {status === "success" && <div className="pdf-progress-check">✓</div>}
          {status === "error" && <div className="pdf-progress-error">×</div>}
        </div>
        <div className="pdf-progress-message">{message}</div>
      </div>
      <style jsx="true">{`
        .pdf-progress-modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
        }
        .pdf-progress-modal {
          background-color: white;
          border-radius: 8px;
          padding: 20px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          text-align: center;
          min-width: 300px;
        }
        .pdf-progress-status {
          margin-bottom: 15px;
        }
        .pdf-progress-spinner {
          border: 4px solid #f3f3f3;
          border-top: 4px solid #3498db;
          border-radius: 50%;
          width: 40px;
          height: 40px;
          animation: spin 2s linear infinite;
          margin: 0 auto;
        }
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        .pdf-progress-check {
          color: #4caf50;
          font-size: 40px;
          font-weight: bold;
        }
        .pdf-progress-error {
          color: #f44336;
          font-size: 40px;
          font-weight: bold;
        }
        .pdf-progress-message {
          font-size: 16px;
          color: #333;
        }
      `}</style>
    </div>
  );
};

const sanitizeFilename = (name) => {
  return name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .replace(/\s+/g, "_")
    .toLowerCase();
};

// Gera o HTML completo
const generateHtml = (data) => {
  const isArray = Array.isArray(data);
  const title = isArray
    ? data[0]?.chapterName || "Capítulo"
    : data.chapterName || data.articleTitle;

  let content = "";

  if (isArray) {
    content = data
      .map((article) => renderArticleHtmlWithPagination(article))
      .join("");
  } else {
    content = renderArticleHtmlWithPagination(data);
  }

  return `
    <div class="pdf-content">
      <style>
        .pdf-content {
          padding: 20px;
          font-family: Arial, sans-serif;
          line-height: 1.6;
        }
        .pdf-content iframe{
          display:none;
        }
        .pdf-content h1 {
          font-size: 24px;
          margin: 20px 0;
          text-align: center;
          color: #283e50;
          break-after: avoid-page;
        }
        .pdf-content h2 {
          font-size: 20px;
          margin: 16px 0;
          color: #1e2a3a;
          break-after: avoid-page;
        }
        .pdf-content p {
          margin: 12px 0;
          text-align: justify;
          font-size: 12px;
        }
        .pdf-content strong {
          font-weight: bold;
        }
        .pdf-content img {
          max-width: 100%;
          height: auto;
          display: block;
          margin: 15px auto;
          page-break-inside: avoid;
        }
        .pdf-content ul, .pdf-content ol {
          margin: 12px 0 12px 25px;
          padding-left: 20px;
          font-size: 12px;
        }
        .pdf-content li {
          margin: 6px 0;
          line-height: 1.4;
        }
        .pdf-content table {
          width: 100%;
          border-collapse: collapse;
          margin: 15px 0;
          page-break-inside: avoid;
        }
        .pdf-content th, .pdf-content td {
          border: 1px solid #ddd;
          padding: 8px;
          font-size: 11px;
        }
        .pdf-content th {
          background-color: #f5f5f5;
        }
        .pdf-content .article {
          margin-bottom: 30px;
          break-inside: avoid-page;
        }
        .pdf-content .article-header {
          break-after: avoid-page;
        }
        .pdf-content .article-content-wrapper {
          break-before: avoid-page;
        }
        .pdf-content .article-content-wrapper p {
          margin: 12px 0;
          text-align: justify;
          font-size: 12px;
          break-inside: avoid;
        }
        .pdf-content h1 {
          font-size: 24px;
          margin: 20px 0;
          text-align: center;
          color: #283e50;
          break-after: avoid-page;
        }
        .pdf-content h2 {
          font-size: 20px;
          margin: 16px 0;
          color: #1e2a3a;
          break-after: avoid-page;
        }
        .pdf-content p {
          margin: 12px 0;
          text-align: justify;
          font-size: 12px;
          page-break-inside: avoid !important;
        }
        .pdf-content img {
          max-width: 100%;
          height: auto;
          display: block;
          margin: 15px auto;
          page-break-inside: avoid;
        }
        .pdf-content ul, .pdf-content ol {
          margin: 12px 0 12px 25px;
          padding-left: 20px;
          font-size: 12px;
          page-break-inside: avoid;
        }
          .pdf-content ul {
    list-style-type: disc !important;
  }
  .pdf-content ol {
    list-style-type: decimal !important;
  }
        .pdf-content li {
          margin: 6px 0;
          line-height: 1.4;
        }
        .pdf-content table {
          width: 100%;
          border-collapse: collapse;
          margin: 15px 0;
          page-break-inside: avoid;
        }
        .pdf-content th, .pdf-content td {
          border: 1px solid #ddd;
          padding: 8px;
          font-size: 11px;
        }
        .pdf-content th {
          background-color: #f5f5f5;
        }
        .pdf-content .article {
          margin-bottom: 30px;
          page-break-inside: avoid;
          display: flex;
          flex-direction: column;
        }
        .pdf-content .article-meta {
          font-size: 10px;
          color: #666;
          margin: 5px 0 15px 0;
          page-break-after: avoid;
        }
        .pdf-content .article-content {
          margin-top: 15px;
          page-break-before: avoid;
        }

        .pdf-content span {
          page-break-before: avoid;
          page-break-inside: avoid;
        }

        .pdf-content li{
        page-break-before: avoid;
          page-break-inside: avoid;
        }


      </style>
      <h1>${title}</h1>
      ${content}
    </div>
  `;
};

// Função principal para gerar o PDF
const GeneratePdf = ({ data, waitingMessage, successMessage }) => {
  return new Promise((resolve, reject) => {
    let modalRoot = null;
    let tempEl = null;

    const showModal = (status, message) => {
      if (!modalRoot) {
        modalRoot = document.createElement("div");
        modalRoot.id = "pdf-progress-modal-root";
        document.body.appendChild(modalRoot);
      }
      ReactDOM.render(
        <ProgressModal status={status} message={message} visible={true} />,
        modalRoot
      );
    };

    const cleanup = () => {
      if (tempEl && document.body.contains(tempEl)) {
        document.body.removeChild(tempEl);
      }
      if (modalRoot) {
        ReactDOM.unmountComponentAtNode(modalRoot);
        if (document.body.contains(modalRoot)) {
          document.body.removeChild(modalRoot);
        }
      }
    };

    try {
      // Show initial loading modal
      showModal("loading", waitingMessage);

      // Create temporary element
      tempEl = document.createElement("div");
      tempEl.innerHTML = generateHtml(data);
      document.body.appendChild(tempEl);

      // Configure PDF options
      const fileName = Array.isArray(data)
        ? sanitizeFilename(data[0]?.chapterName || "documento")
        : sanitizeFilename(data.articleTitle);

      const opt = {
        filename: `${fileName}.pdf`,
        margin: [10, 10],
        image: {
          type: "jpeg", // Change this to handle PNG better
          quality: 0.98,
          scale: 1,
          loading: "eager",
          crossOrigin: "anonymous",
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
          logging: true,
          letterRendering: false,
          allowTaint: false,
          foreignObjectRendering: false,
          imageTimeout: 0,
          backgroundColor: null,
          onclone: (clonedDoc) => {
            const images = clonedDoc.getElementsByTagName("img");
            Array.from(images).forEach((img) => {
              if (!img.parentElement.classList.contains("image-wrapper")) {
                const wrapper = clonedDoc.createElement("div");
                wrapper.className = "image-wrapper";
                img.parentNode.insertBefore(wrapper, img);
                wrapper.appendChild(img);
              }
            });
          },
        },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: {
          mode: ["css", "legacy"],
          // before: ".image-wrapper, h1, h2",
          // avoid: "img, p, .image-wrapper",
        },
      };

      // Generate PDF
      html2pdf()
        .from(tempEl)
        .set(opt)
        .save()
        .then(() => {
          showModal("success", successMessage);
          setTimeout(() => {
            cleanup();
            resolve();
          }, 3000);
        })
        .catch((err) => {
          cleanup();
          reject(err);
        });
    } catch (err) {
      cleanup();
      reject(err);
    }
  });
};

export default GeneratePdf;

const calculateAvailableSpace = (article) => {
  // Create a test element to measure content
  const testEl = document.createElement("div");
  testEl.style.cssText = `
    position: absolute;
    visibility: hidden;
    width: 210mm; /* A4 width */
    padding: 20px;
    font-family: Arial, sans-serif;
    font-size: 12px;
    line-height: 1.6;
  `;

  // Add header content
  const headerEl = document.createElement("div");
  headerEl.innerHTML = `
    <h2>${article.articleTitle}</h2>
    <div>Atualizado em: ${article.updatedAt}</div>
  `;
  testEl.appendChild(headerEl);
  document.body.appendChild(testEl);

  // Calculate available space
  const pageHeight = 297; // A4 height in mm
  const marginTop = 10;
  const marginBottom = 10;
  const headerHeight = headerEl.offsetHeight / 3.78; // Convert px to mm (1mm ≈ 3.78px)
  const availableSpace = pageHeight - marginTop - marginBottom - headerHeight;

  // Cleanup
  document.body.removeChild(testEl);

  return availableSpace;
};

const splitContentIntoChunks = (content, article) => {
  const availableSpace = calculateAvailableSpace(article);
  const testEl = document.createElement("div");
  testEl.style.cssText = `
    position: absolute;
    visibility: hidden;
    width: 210mm;
    padding: 20px;
    font-family: Arial, sans-serif;
    font-size: 12px;
    line-height: 1.6;
  `;
  document.body.appendChild(testEl);

  const chunks = [];
  let currentChunk = [];
  let currentHeight = 0;

  // Parse content into DOM elements
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = content;

  // Process each child node
  tempDiv.childNodes.forEach((node) => {
    const nodeContent = node.outerHTML || node.textContent;
    testEl.innerHTML = nodeContent;
    const nodeHeight = testEl.offsetHeight / 3.78; // Convert to mm

    if (
      currentHeight + nodeHeight > availableSpace &&
      currentChunk.length > 0
    ) {
      chunks.push(currentChunk.join(""));
      currentChunk = [];
      currentHeight = 0;
    }

    currentChunk.push(nodeContent);
    currentHeight += nodeHeight;
  });

  if (currentChunk.length > 0) {
    chunks.push(currentChunk.join(""));
  }

  // Cleanup
  document.body.removeChild(testEl);

  return chunks;
};

// Export the function so it can be used elsewhere
const renderArticleHtmlWithPagination = (article) => {
  const content = article.content.includes("<p")
    ? article.content
    : `<p>${article.content}</p>`;

  const contentChunks = splitContentIntoChunks(content, article);

  const articleSections = contentChunks
    .map(
      (chunk, index) => `
    <div class="article-section" ${index > 0 ? 'data-page-break="true"' : ""}>
      ${
        index === 0
          ? `
        <div class="article-header">
          <h2>${article.articleTitle}</h2>
          <div class="article-meta">Atualizado em: ${article.updatedAt}</div>
        </div>
      `
          : ""
      }
      <div class="article-content-wrapper">
        ${chunk}
      </div>
    </div>
  `
    )
    .join("");

  return `
    <article class="article">
      ${articleSections}
    </article>
  `;
};
